import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Tablet02 = function Tablet02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15 2v1.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C14.2401 5 13.9601 5 13.4 5h-2.8c-.5601 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C9 4.24 9 3.96 9 3.4V2M7.2 22h9.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.4802 20 19.9201 20 18.8V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C18.4802 2 17.9201 2 16.8 2H7.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C4 3.5198 4 4.08 4 5.2v13.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C5.5198 22 6.08 22 7.2 22"
    })
  }));
};
export default Tablet02;